var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFullScreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFullScreen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop--Watcher",
    transform: "translate(-901.000000, -708.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(16.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(638.000000, 350.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fullscreen",
    transform: "translate(232.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 15.000000)",
    id: "icFullScreen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.10526316,2.31578947 L2.31578947,2.31578947 L2.31578947,8.10526316 L0,8.10526316 L0,0 L8.10526316,0 L8.10526316,2.31578947 Z M13.8947368,2.31578947 L13.8947368,0 L22,0 L22,8.10526316 L19.6842105,8.10526316 L19.6842105,2.31578947 L13.8947368,2.31578947 Z M8.10526316,19.6842105 L8.10526316,22 L0,22 L0,13.8947368 L2.31578947,13.8947368 L2.31578947,19.6842105 L8.10526316,19.6842105 Z M13.8947368,19.6842105 L19.6842105,19.6842105 L19.6842105,13.8947368 L22,13.8947368 L22,22 L13.8947368,22 L13.8947368,19.6842105 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFullScreen);
export default __webpack_public_path__ + "static/media/icFullScreen.8ad568b1d784e0b3c88dc042b585a858.svg";
export { ForwardRef as ReactComponent };